import AssetType from 'common/enums/assetTypes';
import { useDispatch } from 'react-redux';
import { addDiscount } from 'redux/slices/discountSlice';
import { setExpandAccordionEdited } from 'redux/slices/eventSlice';

import DiscountForm from './DiscountForm';

const EventDiscountsCreate = (props) => {
    const { closeForm } = props;

    const dispatch = useDispatch();

    const discount = {
        name: '',
        description: '',
        duration: 3600,
        percent: 1,
        type: AssetType.DISCOUNT,
        discountType: 'percent',
        discountCode: '',
    };

    const setNewDiscount = (editedDiscount) => {
        dispatch(addDiscount(editedDiscount));
        dispatch(setExpandAccordionEdited(AssetType.DISCOUNT));
        closeForm();
    };

    return (
        <DiscountForm
            discount={discount}
            onSubmit={setNewDiscount}
            onClose={() => {
                closeForm();
            }}
        />
    );
};

export default EventDiscountsCreate;
